import React from 'react';
import { MapPin } from 'lucide-react';
import { CITIES } from '../data/mock';
import SectionHeading from './SectionHeading';

const Cities = () => {
  return (
    <section id="cities" className="section-pad bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHeading
          eyebrow="Pan-India Presence"
          title="Cities We"
          accent="Serve"
          subtitle="27+ cities and 900+ pin codes — from Delhi's grand weddings to Udaipur's palace celebrations."
        />

        <div className="mt-12 flex flex-wrap gap-2.5 justify-center">
          {CITIES.map((c) => (
            <span
              key={c}
              className="inline-flex items-center gap-1.5 bg-white border border-pink-100 hover:border-pink-brand hover:text-pink-brand text-stone-700 rounded-full px-4 py-2 text-sm font-medium shadow-soft transition-colors cursor-default"
              data-testid={`city-chip-${c.toLowerCase()}`}
            >
              <MapPin className="w-3.5 h-3.5 text-pink-brand" /> {c}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Cities;
